module.exports = __webpack_public_path__ + "img/IND-A-3-V.c603f23b.png";